import React, { useState } from 'react'
import Navbar from './Navbar'
import "../css/petParentData.css"
import Footer from './Footer'


function PetParentData() {

    const [owner, setOwner] = useState({
        petid: '',
        name: '',
        petname: '',
        email: '',
        whatsapp: '',
        contact: '',
        facebook: '',
        note: ''
    })

    const handleChange = (e) => {

        const { name, value } = e.target
        setOwner({ ...owner, [name]: value })
    }

    const register = async (e) => {
        e.preventDefault()
        const { petid, name, petname, email, whatsapp, contact, facebook, note } = owner;
        const res = await fetch("https://petme.onrender.com/owner", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                petid, name, petname, email, whatsapp, contact, facebook, note
            })
        });

        const data = await res.json();

        console.log(JSON.stringify(data.status))

        if (data.status === 422 || !data) {
            window.alert(data.error);
        } else {
            window.alert("Registartion Successfull")
        }

    }


    return (
        <div>

            <Navbar />
            <div className="parent-data-container">

                <div className="petParent-data-div">
                    <h1 className="parent-data-heading">Parent Data</h1>
                    <form action="" className="parent-data-form">

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Parent Name</p>
                                <input id="parent-data" type="form" name="name" value={owner.name} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">Parent Image</p>
                                <input id="parent-data" type="file" name="form" className="parent-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Contact</p>
                                <input id="parent-data" type="form" name="contact" value={owner.contact} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">WhatsApp</p>
                                <input id="parent-data" type="form" name="whatsapp" value={owner.whatsapp} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Email</p>
                                <input id="parent-data" type="form" name="email" value={owner.email} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">Facebook</p>
                                <input id="parent-data" type="form" name="facebook" value={owner.facebook} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="parent-note">
                            <p className="parent-data-details ">Any note about owner</p>
                            <input id="parent-data" type="form" name="note" value={owner.note} onChange={handleChange} className="parent-details-box  parent-note-box" placeholder="" />
                        </div>

                    </form>
                    <button className="parentDetails-submitBtn" onClick={register}>SUBMIT</button>
                </div>
            </div>
            <Footer />

        </div>
    )
}

export default PetParentData